<template>
  <EmailVerificationForm
    :show-left-panel="true"
    :show-logo-link="true"
    :enable-redirect="true"
    :load-email-from-storage="true"
    @goto-login="handleGotoLogin"
    @resend-success="handleResendSuccess"
    @resend-error="handleResendError"
    @email-verified="handleEmailVerified"
  />
</template>

<script setup>
import EmailVerificationForm from "../components/EmailVerificationForm.vue";

// Event handlers for EmailVerificationForm
function handleGotoLogin() {
  // Login navigation is handled by EmailVerificationForm's internal redirect logic
  console.log("Navigating to login");
}

function handleResendSuccess(email) {
  // Resend success is handled by EmailVerificationForm
  console.log("Resend verification successful for:", email);
}

function handleResendError(error) {
  // Error handling is managed by EmailVerificationForm
  console.log("Resend verification error:", error);
}

function handleEmailVerified(data) {
  // Email verification completion
  console.log("Email verified:", data);
}
</script>

<style scoped>
.signup-footer-links {
  cursor: pointer;
  color: #0056b3;
  text-decoration: none;
}
</style>
